import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { HERO, SECTORS } from "@/data/media";
import { Seo } from "@/components/Seo";
import { Check, ArrowRight } from "lucide-react";

export default function About() {
  const { t } = useLang();
  return (
    <div data-testid="about-page">
      <Seo page="about" />
      <PageHero overline={t.about.overline} title={t.about.title} image={HERO.aboutWorkshop} />

      <section className="py-20 md:py-28 bg-cream">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-7 space-y-6">
            <Reveal><p className="text-ink/75 text-lg leading-relaxed">{t.about.p1}</p></Reveal>
            <Reveal delay={100}><p className="text-ink/75 text-lg leading-relaxed">{t.about.p2}</p></Reveal>
            <Reveal delay={200}><p className="text-ink/75 text-lg leading-relaxed">{t.about.p3}</p></Reveal>
          </div>
          <div className="md:col-span-5">
            <Reveal delay={150}>
              <div className="bg-sand p-8 md:p-10 border-t-2 border-brass">
                <h3 className="font-serif-display text-2xl text-ink mb-6">{t.about.productsTitle}</h3>
                <ul className="grid grid-cols-2 gap-x-6 gap-y-4">
                  {t.about.products.map((p, i) => (
                    <li key={i} className="flex items-center gap-2 text-ink/80">
                      <Check className="w-4 h-4 text-brass shrink-0" />
                      <span className="text-sm">{p}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Volume */}
      <section className="relative py-24 md:py-32 bg-ink text-white overflow-hidden">
        <img src={SECTORS.palazzi} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-ink/70" />
        <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <p className="overline mb-5">01</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl tracking-tight">{t.about.volumeTitle}</h2>
            <p className="mt-6 text-white/70 text-lg leading-relaxed max-w-2xl mx-auto">{t.about.volumeText}</p>
          </Reveal>
        </div>
      </section>

      {/* Materials */}
      <section className="py-20 md:py-28 bg-cream">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid md:grid-cols-2 gap-12 items-center">
          <Reveal>
            <div className="aspect-[4/3] overflow-hidden">
              <img src={SECTORS.tessuti} alt={t.about.materialsTitle} className="w-full h-full object-cover" />
            </div>
          </Reveal>
          <Reveal delay={150}>
            <p className="overline mb-5">02</p>
            <h2 className="font-serif-display font-light text-4xl md:text-5xl tracking-tight text-ink">{t.about.materialsTitle}</h2>
            <p className="mt-6 text-ink/70 text-lg leading-relaxed">{t.about.materialsText}</p>
            <Link to="/settori" data-testid="about-sectors-link" className="mt-8 inline-flex items-center gap-2 text-ink font-medium border-b-2 border-brass pb-1 hover:gap-3 transition-all">
              {t.nav.sectors} <ArrowRight className="w-4 h-4 text-brass" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
